import { useParams } from 'react-router-dom';
import {  useEffect } from 'react';

// @mui
import {  useTheme } from '@mui/material/styles';
import { Box, Card, Grid, Container, Typography } from '@mui/material';
// components
import { FeatureWidget, ContactWidget } from '../../sections/web/home';

import { ServiceHero, MoreServiceWidget } from '../../sections/web/service';
import HeaderBreadcrumbs from '../../components/header-breadcrumbs';
import {Widget404, LoadSkeleton} from '../../components/widegts';
import Markdown from '../../components/markdown';
import { Seo, breadcrumbSchema, serviceSchema, truncateText } from '../../components/seo';

// redux
import { useDispatch, useSelector } from '../../redux/store';

// data
import { getService } from '../../redux/slices/course';

// ----------------------------------------------------------------------

export default function ServiceDetailpage() {
  const { serviceslug } = useParams();
  const theme = useTheme();
  const dispatch = useDispatch();
  const { service, error, isLoading } = useSelector((state) => state.course);

  useEffect(() => {
    dispatch(getService(serviceslug));
  }, [dispatch, serviceslug]);

  if (!service && isLoading) {
    return (
    <LoadSkeleton />
    );
  }
  if (!service && error) {
    return (
      <Widget404 item='Service' subitem={`No data found as ${serviceslug}`}/>    

    );
  }
  if (!service ) {
    return (
      <LoadSkeleton />
    );
  }
  
  const pageTitle=  service ? service.title :serviceslug;

  // Structured data mirrors what the page renders: the service entity plus the
  // visible breadcrumb trail (Home > Services > this service).
  const jsonLd = [
    serviceSchema({
      name: pageTitle,
      description: service.intro,
      path: `/service/${serviceslug}`,
    }),
    breadcrumbSchema([
      { name: 'Home', path: '/' },
      { name: 'Services', path: '/services' },
      { name: pageTitle, path: `/service/${serviceslug}` },
    ]),
  ];

  return (
    <>
      <Seo
        title={pageTitle}
        description={truncateText(
          `${service.intro ? `${service.intro} ` : ''}Get ${pageTitle} support from ASAP UAE — document guidance, eligibility help and exam preparation.`
        )}
        path={`/service/${serviceslug}`}
        jsonLd={jsonLd}
      />

      <Container maxWidth="xl">
      <HeaderBreadcrumbs
          heading={pageTitle}
          headingComponent="div"
          links={[
            {
              name: 'Services',
              href: '/services',
            },
            { name: `${pageTitle}` }
          ]}
        />
        <Card sx={{my:theme.spacing(3)}}>
         <ServiceHero service={service}/>
         <Box sx={{ p: { xs: 3, md: 5 } }}>
              {/* Lead paragraph, not a heading. */}
              <Typography component="p" variant="h6" sx={{ mb: 5 }}>
                {service.intro}
              </Typography>

              <Markdown children={service.body} />
              </Box>
         </Card>
        <Grid container spacing={3}>
       

          <Grid item xs={12}>
            <FeatureWidget />
          </Grid>
          <Grid item xs={12}>
          <Typography component="h2" variant="h3" sx={{ color: '#000', display: 'block', textAlign: 'center' }}>
              More Services
            </Typography>
           
          <MoreServiceWidget currentservice={serviceslug} />
          </Grid>

          <Grid item xs={12}>
            <ContactWidget />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
